<template>
  <div class="col-12 col-md-3 d-flex flex-column my-3" :class="{ 'd-none': shouldHide }">
    <button @mouseover="ajustarPosicaoDiv" :horario="prophorarioLimpo"
      :disabled="isIndisponivel || statusdia === '0' || shouldHide" :class="[
        'roteiros',
        'bfirst',
        'btn',
        'position-relative',
        'btn-success',
        'text-light',
        { indisponivel: isIndisponivel, 'd-none': shouldHide },
      ]" @click="emitirEvento">
      <p>
        {{
          texto === "R14" ||
          condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"
            ? "Roteiro Livre - 50 vagas"
            : nome
        }}
      </p>
      <p>
        {{
          texto === "R14" ||
          condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"
            ? "Não há monitoria"
            : itens
        }}
      </p>
      <p>
        <b>
          Faixa etária:
          {{
            texto === "R14" ||
            condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"
              ? "Livre"
              : faixa
          }}
        </b>
      </p>

      <div class="position-absolute" :style="divStyle">
        <p>
          <b>
            {{
              texto === "R14" ||
                            condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"

                ? "Roteiro Livre - 50 vagas"
            : nome
            }}
          </b>
        </p>

        <p>
          {{
            texto === "R14" ||
            condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"
              ? "Não há monitoria"
              : itens
          }}
        </p>
        <p>
          <b>
            {{
              texto === "R14" ||
                            condicaoferiado === "sábado" ||
            condicaoferiado === "domingo" ||
            condicaoferiado2 === "14/02/2024" ||
            condicaoferiado2 === "29/03/2024" ||
            condicaoferiado2 === "30/05/2024" ||
            condicaoferiado2 === "31/05/2024" ||
            condicaoferiado2 === "01/05/2024" ||
            condicaoferiado2 === "13/02/2024" ||
            condicaoferiado2 === "01/07/2024" ||
            condicaoferiado2 === "02/07/2024" ||
            condicaoferiado2 === "03/07/2024" ||
            condicaoferiado2 === "04/07/2024" ||
            condicaoferiado2 === "05/07/2024" ||
            condicaoferiado2 === "06/07/2024" ||
            condicaoferiado2 === "07/07/2024" ||
            condicaoferiado2 === "08/07/2024" ||
            condicaoferiado2 === "09/07/2024" ||
            condicaoferiado2 === "10/07/2024" ||
            condicaoferiado2 === "11/07/2024" ||
            condicaoferiado2 === "12/07/2024" ||
            condicaoferiado2 === "13/07/2024" ||
            condicaoferiado2 === "14/07/2024" ||
            condicaoferiado2 === "15/07/2024" ||
            condicaoferiado2 === "16/07/2024" ||
            condicaoferiado2 === "17/07/2024" ||
            condicaoferiado2 === "18/07/2024" ||
            condicaoferiado2 === "19/07/2024" ||
            condicaoferiado2 === "20/07/2024" ||
            condicaoferiado2 === "21/07/2024" ||
            condicaoferiado2 === "22/07/2024" ||
            condicaoferiado2 === "23/07/2024" ||
            condicaoferiado2 === "24/07/2024" ||
            condicaoferiado2 === "25/07/2024" ||
            condicaoferiado2 === "26/07/2024" ||
            condicaoferiado2 === "27/07/2024" ||
            condicaoferiado2 === "28/07/2024" ||
            condicaoferiado2 === "29/07/2024" ||
            condicaoferiado2 === "30/07/2024" ||
            condicaoferiado2 === "31/07/2024"
                ? ""
                : faixa
            }}
          </b>
        </p>
      </div>
    </button>
    <button :disabled="isIndisponivel" class="btn btn-dark badmin mt-1" :class="{ 'd-none': shouldHide }"  v-if="isAdministrator" @click="reservaadmin">
      Reserva administrativa
    </button>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import axios from "axios";
import { getCurrentUser } from "@/services/authService";

export default {
  name: "BotaoRoteiro",
  props: {
    propdate: Date,
    prophoje: Date,
    prophorario: String,
    idsIndisponiveis: Array,
    texto: String,
    propsemana: String,
    statusdia: String,
    condicaoferiado: String,
    condicaoferiado2: String,
  },
  setup(props, { emit }) {
    const prophorarioLimpo = computed(() => {
      return props.prophorario.replace(/f/gi, "");
    });

    const isAdministrator = computed(
      () => getCurrentUser().emails === "admin.agendamento@cataventomaster.com"
    );

    const formatData = () => {
      const regex = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      return props.prophorario.replace(regex, "$1-$2-$3");
    };

    const reservaadmin = () => {
      addId();
      
      let cnpja = "08.698.186/0001-06";
      let formData = {
        cnpj: cnpja,
        agencia: "Administrador",
        nomecontato: "Administrador",
        cargo: "Administrador",
        deficiencia: "",
        email: getCurrentUser().emails,
        endereco: "Administrador",
        id: props.prophorario,
        quantidade: "Administrador",
        series: ["Administrador"],
        obs: "Administrador",
        tipo: "Administrador",
        diamaster: formatData(),
        aprovacao: "2",
        instituicao: "Reservado pelo Administrador",
      };
      axios
        .post(
          "https://museucatavento.org.br/sistema-agendamento/api.php",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          alert(response.data);
        })
        .catch((error) => {
          alert(error);
        });
    };

    const divStyle = ref({ top: "20px", left: "-30px" });

    const ajustarPosicaoDiv = (event) => {
      const botaoRect = event.currentTarget.getBoundingClientRect();
      let novaPosicao = { top: "20px", left: "-30px" };

      if (window.innerWidth - botaoRect.right < 200) {
        novaPosicao.left = `-${200 - (window.innerWidth - botaoRect.right)}px`;
      }

      divStyle.value = novaPosicao;
    };

    const objeto = [
      {
        nome: "R1",
        roteiro: "Roteiro 1 - 48 vagas",
        itens: ["Sociedade", "Matéria", "Astronomia"],
        faixaEtaria: "A partir de 8 anos - Duração da Visita 2 horas",
      },
      {
        nome: "R2",
        roteiro: "Roteiro 2 - 44 vagas",
        itens: ["Aventura no sistema Solar", "Engenho", "Astronomia"],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R3",
        roteiro: "Roteiro 3 - 44 vagas",
        itens: ["Submarino", "Vida", "Borboletário"],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R4",
        roteiro: "Roteiro 4 - 42 vagas",
        itens: ["Dinos do Brasil", "Biosfera", "Sociedade"],
        faixaEtaria: "A partir de 9 anos - Duração da Visita 2 horas",
      },
      {
        nome: "R5",
        roteiro: "Roteiro 5 - 40 vagas",
        itens: ["Vida", "Laboratório de Química", "Escalada dos Sábios"],
        restrições:
          "Altura mínima de 1m e 30cm, obrigatório tênis fechado e como vestimenta short ou calça  - Duração da Visita 2 horas",
      },
      {
        nome: "R6",
        roteiro: "Roteiro 6 - 60 vagas",
        itens: ["Vida", "Astronomia", "Terra"],
        faixaEtaria: "Livre - Duração da Visita 1 hora e 30min",
      },
      {
        nome: "R7",
        roteiro: "Roteiro 7 - 50 vagas",
        itens: ["Alertas", "Sociedade", "Engenho"],
        faixaEtaria: "a partir de 12 anos - Duração da Visita 2 horas",
      },
      {
        nome: "R8",
        roteiro: "Roteiro 8 - 40 vagas",
        itens: [
          "O mundo do Perfume",
          "Nutrição, Movimento e Diversão",
          "Laboratório de Química",
        ],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R9",
        roteiro: "Roteiro 9 - 40 vagas",
        itens: ["Estúdio", "Ensinando Robôs", "Engenho"],
        faixaEtaria: "A partir de 8 anos - Duração da Visita 2 horas",
      },
      {
        nome: "R10",
        roteiro: "Roteiro 10 - 40 vagas",
        itens: ["Laboratório de Química", "Vida", "Engenho"],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R11",
        roteiro: "Roteiro 11 - 48 vagas",
        itens: ["Engenho", "Terra", "Do Macaco ao Homem"],
        faixaEtaria: "A partir de 8 anos - Duração da Visita 2 horas",
      },
      {
        nome: "R12",
        roteiro: "Roteiro 12 - 60 vagas",
        itens: ["Engenho", "Vida", "Sociedade"],
        faixaEtaria: "Livre - Duração da Visita 1 hora e 30 min",
      },
      {
        nome: "R13",
        roteiro: "Roteiro 13 - Acessível  - 50 vagas",
        itens: [
          "Dedicado para diversos perfis de público, passando pelas principais sessões terreas: Astronomia, Terra, Vida e Engenho",
        ],
        faixaEtaria: "Livre - Duração da Visita 1 hora e 30 min",
      },

      {
        nome: "R14",
        roteiro: "Roteiro Livre - 46 vagas",
        itens: ["Roteiro livre"],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R15",
        roteiro: "Roteiro 15 - 50 vagas",
        itens: ["Engenho", "Santos Dumont", "Dinâmica"],
        faixaEtaria: "Livre - Duração da Visita 2 horas",
      },
      {
        nome: "R16",
        roteiro: "Roteiro 16 - 50 vagas",
        itens: [
          "Hungria na Vanguarda da Ciência",
          "Vida",
          "Vacina: Uma Vitória para Todos",
        ],
        faixaEtaria: "A partir de 8 anos - Duração da Visita 2 horas",
      },
    ];

    const roteiroSelecionado = computed(() => {
      return objeto.find((roteiro) => roteiro.nome === props.texto);
    });

    const nome = computed(() => {
      return roteiroSelecionado.value ? roteiroSelecionado.value.roteiro : "";
    });

    const itens = computed(() => {
      return roteiroSelecionado.value
        ? roteiroSelecionado.value.itens.join(", ")
        : "";
    });

    const faixa = computed(() => {
      return roteiroSelecionado.value
        ? roteiroSelecionado.value.faixaEtaria ||
        roteiroSelecionado.value.restrições
        : "";
    });

    const isIndisponivel = computed(() => {
      return props.idsIndisponiveis.includes(props.prophorario);
    });

    const isAugust2024 = computed(() => {
      if (!props.condicaoferiado2) return false;
      const date = new Date(props.condicaoferiado2);
      return date.getFullYear() === 2024 && date.getMonth() === 7;
    });

    const shouldHide = computed(() => {
      return props.texto === 'R13' || props.texto === 'R15' || props.texto === 'R16' || isAugust2024.value;
    });

    const emitirEvento = () => {
      addId();
      if (isAdministrator.value) {
        console.log("administrando");
      }
    };

    const id = computed(() => {
      return props.prophorario;
    });

    const acao = ref("adicionar");

    const addId = async () => {
      console.log("Este é o ID selecionado pelo botão:" + id.value);
      try {
        const response = await axios.post(
          "https://museucatavento.org.br/sistema-agendamento/verificaid.php",
          `id=${id.value}&acao=${acao.value}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.success) {
          if (!isIndisponivel.value) {
            emit("estadoRoteiro", { codigoin: prophorarioLimpo.value });
          }
          id.value = "";
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error("Erro ao adicionar ID:", error);
        alert("Informe ao Desenvolvedor o erro:" + error);
      }
    };

    return {
      id,
      acao,
      addId,
      reservaadmin,
      ajustarPosicaoDiv,
      divStyle,
      emitirEvento,
      isIndisponivel,
      nome,
      isAdministrator,
      itens,
      faixa,
      prophorarioLimpo,
      shouldHide,
    };
  },
};
</script>

<style lang="scss" scoped>
button {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  line-height: 1.35;
  border: 0;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;

  &.bfirst {
    min-height: 180px;
    padding: 0.9rem;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  }

  align-items: center;

  &.badmin {
    min-height: 30px !important;
  }

  div {
    display: none;
    background-color: white;
    color: var(--catavento-text, #243447);
    padding: 1rem;
    width: min(300px, calc(100vw - 2rem));
    border: 1px solid var(--catavento-border, #d9e1ea);
    border-radius: var(--catavento-radius, 8px);
    box-shadow: var(--catavento-shadow, 0 10px 28px rgba(20, 30, 45, 0.12));
    z-index: 99;
    top: 15px;
    font-size: 0.95rem;
    left: -30px;
    text-align: left;
  }

  &:hover {
    transform: translateY(-1px);
    filter: brightness(0.98);

    div {
      display: inline-block;
    }
  }

  p {
    margin-bottom: 0.45rem;
  }
}

.indisponivel {
  background-color: #c24a4a !important;
  opacity: 1;
}

@media (max-width: 767px) {
  button {
    font-size: 0.9rem;

    &.bfirst {
      min-height: 132px;
    }

    div {
      display: none !important;
    }
  }
}
</style>
